import { __decorate, __metadata, __param } from "tslib";
import _ from 'lodash';
import { Symbols } from '@/symbols';
import { inject, injectable } from 'inversify';
import { E_ResourceCategory, E_ResourceCyclical, E_ResourceStatus } from '@/apis/service/CompanyPermissionApi.type';
import { boPaginationLoadAll } from '../@core/utils/pagination';
let PermissionService = class PermissionService {
    constructor(productService, companyResourceApi, i18n) {
        this.productService = productService;
        this.companyResourceApi = companyResourceApi;
        this.i18n = i18n;
        this.KeyRule = 'required|max:128|digitNumberUnderline';
        this.NameRule = 'required|max:256|permissionName';
        this.DescRule = 'required|max:2048';
        this.getProductionProducts = this.productService.getProductionProducts;
        this.getProductResourceList = this.companyResourceApi.getProductResourceList;
        this.postResourceCreate = this.companyResourceApi.postResourceCreate;
        this.putResourceEdit = this.companyResourceApi.putResourceEdit;
        this.getCapacityList = this.companyResourceApi.getCapacityList;
        this.postCapacityCreate = this.companyResourceApi.postCapacityCreate;
        this.putCapacityEdit = this.companyResourceApi.putCapacityEdit;
        this.getService = this.companyResourceApi.getService;
        this.getServiceList = this.companyResourceApi.getServiceList;
        this.postServiceCreate = this.companyResourceApi.postServiceCreate;
        this.putServiceEdit = this.companyResourceApi.putServiceEdit;
        this.putServicePriceEdit = this.companyResourceApi.putServicePriceEdit;
        this.postServiceClone = this.companyResourceApi.postServiceClone;
        this.getServiceResourceLimitationsList = this.companyResourceApi.getServiceResourceLimitationsList;
        this.postServiceResourceLimitationsCreate = this.companyResourceApi.postServiceResourceLimitationsCreate;
        this.putServiceResourceLimitationsEdit = this.companyResourceApi.putServiceResourceLimitationsEdit;
        this.putServiceResourceLimitationsDelete = this.companyResourceApi.putServiceResourceLimitationsDelete;
        this.postServicePerformanceLimitationsCreate = this.companyResourceApi.postServicePerformanceLimitationsCreate;
        this.putServicePerformanceLimitationsEdit = this.companyResourceApi.putServicePerformanceLimitationsEdit;
        this.putServicePerformanceLimitationsDelete = this.companyResourceApi.putServicePerformanceLimitationsDelete;
        this.getCapacityResouceByFeature = this.companyResourceApi.getCapacityResouceByFeature;
        this.ResourceStatusList = [
            E_ResourceStatus.DISABLED,
            E_ResourceStatus.ENABLED
        ];
        this.CategoriesList = [
            E_ResourceCategory.DATA,
            E_ResourceCategory.USAGE,
            E_ResourceCategory.MAXIMUM
        ];
        this.ResourceCyclicalList = [
            E_ResourceCyclical.NONE,
            E_ResourceCyclical.YEARLY,
            E_ResourceCyclical.MONTHLY,
            E_ResourceCyclical.WEEKLY,
            E_ResourceCyclical.DAILY,
            E_ResourceCyclical.HOURLY,
            E_ResourceCyclical.MINUTELY
        ];
        this.PerformanceeCyclicalList = [
            E_ResourceCyclical.HOURLY,
            E_ResourceCyclical.MINUTELY
        ];
    }
    showName(item) {
        return this.i18n.locale === 'cn' ? item.name_cn : item.name_us;
    }
    showProduct(product) {
        return this.i18n.locale === 'cn' ? product.alias_cn : product.alias_en;
    }
    showPermissionCapacityItem(item) {
        return this.i18n.locale === 'cn' ? item.capacity_name_cn : item.capacity_name_us;
    }
    showResource(resource) {
        const nameParts = [resource.alias];
        if (resource.http_method) {
            nameParts.push(resource.http_method);
        }
        return _.join(nameParts, ' - ');
    }
    showResourceCyclical(cycle) {
        if (!cycle) {
            cycle = E_ResourceCyclical.NONE;
        }
        return this.i18n.t('enum.E_ResourceCyclical.' + cycle);
    }
    showPermissionResource(resource) {
        return (this.i18n.locale === 'cn' ? resource.name_cn : resource.name_us) || resource.id;
    }
    showResourceStatus(status) {
        return status === E_ResourceStatus.ENABLED ? this.i18n.t('backoffice.resource.disable') : this.i18n.t('backoffice.resource.enable');
    }
    showConfirmDialog(vm, options) {
        const { title, content, } = options;
        return vm.$swal({
            title,
            html: content,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: this.i18n.t('backoffice.common.confirm'),
            cancelButtonText: this.i18n.t('backoffice.common.cancel'),
            customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-outline-danger ml-1',
            },
            buttonsStyling: false,
        });
    }
    loadAllPermissionResource(product_id) {
        const task = (params) => this.getResourceList({
            product_ids: [product_id],
            status: E_ResourceStatus.ENABLED,
            ...params,
        });
        return boPaginationLoadAll(task);
    }
    async getResourceList(params) {
        const data = await this.companyResourceApi.getResourceList(params);
        const aaData = _.map(data.aaData, (el) => {
            const feature_roles_display = _.map(el.feature_roles, (el) => {
                return (this.i18n.locale === 'cn' ? el.role_name_cn : el.role_name_us) || el.role_name;
            });
            const feature_role_ids = _.map(el.feature_roles, (el) => {
                return el.role_id;
            });
            return { ...el, feature_roles_display, feature_role_ids };
        });
        return { ...data, aaData };
    }
};
PermissionService = __decorate([
    injectable(),
    __param(0, inject(Symbols.ProductService)),
    __param(1, inject(Symbols.CompanyPermissionApi)),
    __param(2, inject(Symbols.I18n)),
    __metadata("design:paramtypes", [Object, Object, Object])
], PermissionService);
export { PermissionService };
